module.exports = __webpack_public_path__ + "static/media/img3.58fc8b37.jpg";